import { ThemeClassNames } from "~/theme/actions";
import RootState from "~/types/store";

export const THEME_STATE_KEY = "THEME_STATE";

export const getCurrentTheme = (state: RootState): ThemeClassNames => {
    return state[THEME_STATE_KEY].themeClassName;
};

export const getIsLoading = (state: RootState): boolean => {
    return state[THEME_STATE_KEY].isLoading;
};
